import Component from '../../components/component/component';

import './b2b-info.scss';
export default class B2BInfo extends Component {
    static initSelector: string = '.b2bInfo';

    showB2BInfo: HTMLInputElement;
    b2bInfoContainer: HTMLDivElement;
    companyNameInput: HTMLInputElement;
    companyRegistrationNrInput: HTMLInputElement;
    companyVatNrInput: HTMLInputElement;

    constructor(target: HTMLElement) {
        super(target);


        this.b2bInfoContainer = this.element.querySelector('.b2bInfo__company-details-section');

        this.showB2BInfo = this.element.querySelector(
            '#show-b2b-company-details',
        );

        this.companyNameInput = this.element.querySelector(
            '.b2b-info__company-name',
        );

        this.companyRegistrationNrInput = this.element.querySelector(
            '.b2b-info__company-registration-nr',
        );

        this.companyVatNrInput = this.element.querySelector(
            '.b2b-info__company-vat-nr',
        );

        this.init();
    }

    onShowB2bInfo(): void {
        if (this.showB2BInfo.checked) {
            this.b2bInfoContainer.style.display = 'block';
            this.companyNameInput.focus();
        } else {
            this.b2bInfoContainer.style.display = 'none';
        }
    }

    init(): void {
        this.showB2BInfo.addEventListener('change', this.onShowB2bInfo.bind(this));


        this.onShowB2bInfo();
    }


}
